import { type FC } from 'react';
import classes from './ConfirmSteps.module.scss';
import Step from './Step';
import { useTranslation } from 'react-i18next';

interface ConfirmStepsProps {
    activeStep?: 1 | 2;
}

const ConfirmSteps: FC<ConfirmStepsProps> = ({ activeStep = 1 }) => {
    const { t } = useTranslation('components');
    return (
        <div className={classes.wrapper}>
            <div className={classes.inner_container}>
                <Step number={1} label={t('components:confirm.steps.step1')} isActive />
                <div className={classes.line} />
                <Step number={2} label={t('components:confirm.steps.step2')} isActive={activeStep === 2} />
            </div>
        </div>
    );
    
};

export default ConfirmSteps;